import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { UnifiedAgentSidebar } from './shared/UnifiedAgentSidebar';
import { AgentSessionProvider } from './shared/AgentSessionContext';
import { ChatPage } from './ChatPage';
import { LayoutSidebar } from '../../Layout';
import { APIClient } from '../../utils/APIClient';
import { API_URL } from '../../settings/local_settings';

export const AgentArea = () => {
    const [clients, setClients] = useState([]);
    const [isLoadingClients, setIsLoadingClients] = useState(true);
    const [chatKey, setChatKey] = useState(0);
    const { sessionId } = useParams();

    const handleNewChat = useCallback(() => {
        setChatKey(k => k + 1);
    }, []);

    useEffect(() => {
        setIsLoadingClients(true);
        new APIClient(API_URL + 'agent/get_clients/?assigned_only=true').call('GET').then(data => {
            if (data && Array.isArray(data)) {
                setClients(data.map(c => ({ id: c.id, name: c.name })));
            }
        }).finally(() => {
            setIsLoadingClients(false);
        });
    }, []);

    return (
        <div className="app-content">
            <LayoutSidebar/>
            <section className="section-content agent-area-wrapper">
                <AgentSessionProvider entryPoint="global" clientId={null} activeSessionId={sessionId}>
                    <div className="agent-area">
                        <UnifiedAgentSidebar
                            clients={clients}
                            onNewChat={handleNewChat}
                        />
                        <ChatPage key={chatKey} clients={clients} isLoadingClients={isLoadingClients} />
                    </div>
                </AgentSessionProvider>
            </section>
        </div>
    );
};
